import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import myStore from "./store/store";

Vue.use(ElementUI);

import VideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'

import 'vue-video-player/src/custom-theme.css'

Vue.use(VideoPlayer)

Vue.prototype.myStore = myStore;
// 定义全局点击函数
Vue.prototype.globalClick = function(callback) {
    document.getElementsByTagName('body')[0].onclick = function() {
        callback();
    };
};

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  let deviceNo = to.params.deviceNo;
  if(typeof(deviceNo) !== "undefined") {
    myStore.setDeviceNoAction(deviceNo);
    localStorage.setItem('deviceNo', deviceNo)
  }
  next();    
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
